import CreatePropertyAlert from './allhomes-create-property-alert';
export default CreatePropertyAlert;